class SlideshowHeroComponent extends HTMLElement {
  constructor() {
    super()
    this.initFlickity()
  }

  initFlickity(designMode) {
    const slideShow = this.querySelector('.slideshow')
    const _self = this
    const options = {
      autoPlay: slideShow.dataset.autoplay === 'false' ? 0 : (parseInt(slideShow.dataset.speed, 10) * 1000),
      pageDots: slideShow.dataset.visual === 'dots' ? true : false,
      prevNextButtons: slideShow.dataset.visual === 'arrows' ? true : false,
      arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      dragThreshold: 30,
      on: {
        ready: function() {
          setTimeout(function(){
            _self.classList.remove('_slideshow-loading')
          },500)
        }
      }
    }
    this.classList.add('_slideshow-loaded')
    const flkty = new Flickity( slideShow, { ...options })
    if (designMode) {
      flkty.resize()
    }
  }

}

customElements.define('slideshow-hero-component', SlideshowHeroComponent)

class CarouselComponent extends HTMLElement {
  constructor() {
    super()
    this.initFlickity()
  }

  initFlickity(designMode) {
    let desktopFlickity = false
    let mobileFlickity = false
    let flkty
  
    if (this.dataset.desktopCarousel === 'true') desktopFlickity = true
    if (this.dataset.mobileCarousel === 'true') mobileFlickity = true

    if (desktopFlickity) {
      this.flickityConfig(designMode)
      return
    }
    if (mobileFlickity && window.innerWidth < 750) {
      flkty = this.flickityConfig(designMode)
    }
    const query = matchMedia('(max-width: 749px)')
    const _self = this
    query.addEventListener('change', function (e) {
      if (e.matches) {
        flkty = _self.flickityConfig(designMode)
        return
      }
      flkty.destroy()
    })
    return
  }

  flickityConfig(windowWidth, desktopFlickity, mobileFlickity, designMode) {
      const carousel = this.querySelector('.carousel[data-carousel*="carousel-"]')
      const wrapAround = this.dataset.infiniteCarousel === 'true'
      const freeScroll = this.dataset.freeScroll === "true"
      const autoPlay = this.dataset.autoPlay === "true"
      const options = {
        pageDots: true,
        prevNextButtons: true,
        arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
        cellAlign: 'left',
        contain: true,
        wrapAround,
        freeScroll,
        autoPlay,
        dragThreshold: 30
      }
      const flkty = new Flickity( carousel, { ...options })
      if (designMode) {
        flkty.resize()
      }
      return flkty
  }
}

customElements.define('carousel-component', CarouselComponent)

class ProductCarousel extends HTMLElement {
  constructor() {
    super()
    this.initFlickity()
  }

  initFlickity(index, designMode) {
    this.initMainCarousel(index, designMode)
    this.initThumbnails(designMode)
    this.initMobileCarousel(index, designMode)
  }

  initThumbnails(designMode) {
    const mediaGallery = this.closest('media-gallery[data-desktop-layout="thumbnail_slider"]')
    if (mediaGallery === null) return
    const thumbnails = this.querySelector('.thumbnail-list')
    if (thumbnails === null) return
    const options = {
      pageDots: false,
      prevNextButtons: false,
      arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
      cellAlign: 'left',
      contain: true,
      asNavFor: '.product__media-list',
      dragThreshold: 30
    }
    const flkty = new Flickity( thumbnails, { ...options })
    if (designMode) {
      flkty.resize()
    }
  }

  initMainCarousel(index, designMode) {
    const mediaGallery = this.closest('media-gallery[data-desktop-layout="thumbnail_slider"]')
    if (mediaGallery === null) return
    const mediaList = this.querySelector('.product__media-list')
    if (mediaList === null) return
    const options = {
      pageDots: true,
      prevNextButtons: false,
      arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
      cellAlign: 'left',
      contain: true,
      dragThreshold: 30
    }
    const flkty = new Flickity( mediaList, { ...options })
    if(typeof index !== 'undefined') {
      flkty.select(parseInt(index), false, true)
    }
    if (designMode) {
      flkty.resize()
    }
    return
  }

  mobileFlickityConfig(currentWidth, index, designMode) {
    if (currentWidth >= 750) return
    const mediaList = this.querySelector('.product__media-list')
    if (mediaList === null) return
    const options = {
      pageDots: true,
      prevNextButtons: false,
      arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
      cellAlign: 'left',
      contain: true,
      dragThreshold: 30
    }
    const flkty = new Flickity( mediaList, { ...options })
    if(typeof index !== 'undefined') {
      flkty.select(parseInt(index))
    }
    if (designMode) {
      flkty.resize()
    }
    return flkty
  }

  initMobileCarousel(index, designMode) {
    const mediaGallery = this.closest('media-gallery[data-desktop-layout="thumbnail_slider"]')
    if (mediaGallery !== null) return
    const query = matchMedia('(max-width: 749px)')
    const _self = this
    let flkty = this.mobileFlickityConfig(window.innerWidth, index, designMode)
    query.addEventListener('change', (event) => {
      if (event.matches) {
        flkty = _self.mobileFlickityConfig(window.innerWidth)
        flkty.resize()
        return
      }
      flkty.destroy()
    })
  }
}

customElements.define('product-carousel', ProductCarousel)